// Pagination.js
import React from "react";
import { useTranslation } from "react-i18next";



const Pagination = ({ currentPage, lastPage, onPrev, onNext, onPageClick }) => {

  const { t } = useTranslation();

  const renderPagination = () => {
    const pages = [];
    const windowSize = 5;
    const halfWindowSize = Math.floor(windowSize / 2);

    for (let i = 1; i <= lastPage; i++) {
      if (i === 1 || i === lastPage || (i >= currentPage - halfWindowSize && i <= currentPage + halfWindowSize)) {
        pages.push(
          <li key={i}>
            <a onClick={() => onPageClick(i)} className={i === currentPage ? "active" : ""}>
              {i}
            </a>
          </li>
        );
      } else if (
        i === currentPage - halfWindowSize - 1 ||
        i === currentPage + halfWindowSize + 1
      ) {
        pages.push(<span key={i}>...</span>);
      }
    }

    return pages;
  };

  return (
    <ul className="page-pagination section-space--top--10">
      <li>
        {currentPage > 1 ? (
          <a onClick={onPrev}>
            <i className="prev_class" />  {t("prev")}
          </a>
        ) : (
          <a className="disabled" title="First Page">
            <i className="prev_class" />{t("prev")} 
          </a>
        )}
      </li>
      {renderPagination()}
      <li>
        {currentPage < lastPage ? (
          <a onClick={onNext}>
            <i className="next_class" />{t("next")}  
          </a>
        ) : (
          <a className="disabled">
            <i className="next_class" /> {t("next")}  
          </a>
        )}
      </li>
    </ul>
  );
};

export default Pagination;